import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input, Space, Table, message } from "antd";
import { ColumnType, TablePaginationConfig } from "antd/es/table";
import { CheckCircleFilled, CloseCircleFilled, SearchOutlined } from "@ant-design/icons";
import moment from "moment";
import DeviceApi from "../../../../../../api/DeviceApi";
import GatewayApi from "../../../../../../api/GatewayApi";
import KeyCodeUtils from "../../../../../../util/KeyCodeUtils";
import { FilterItem, FilterItemLabel, GatewaySlaveDevicesWrapper, TableWrapper, ToolBarLeftWrapper, ToolBarRightWrapper, ToolBarWrapper } from "./GatewaySlaveDevices.styled";

interface GatewaySlaveDevicesProps {
    gatewayView: any
}

interface TableParams {
    pagination?: TablePaginationConfig;
}

const GatewaySlaveDevices: React.FC<GatewaySlaveDevicesProps> = (props)=> {
    let { gatewayView } = props ;

    // api
    let deviceApi = new DeviceApi();
    let gatewayApi = new GatewayApi();
    let [messageApi, contextHolder] = message.useMessage();
    let navigate = useNavigate();
    
    // state
    let [deviceViews, setDeviceViews] = useState([]);
    let [loading, setLoading] = useState(true);
    let [search, setSearch] = useState("");
    let [tableParams, setTableParams] = useState<TableParams>({
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0,
            showSizeChanger: true,
            pageSizeOptions: [10, 20, 50],
        },
    });

    // events
    let viewDeviceDetails = (deviceView: any)=> {
        navigate(`/device-management/device/${deviceView.device.id}`);
    };

    let onTableChange = (pagination)=> {
        tableParams.pagination = pagination;
        setTableParams({pagination: pagination});
        loadDeviceViews();
    };

    let onSearchKeyDown = (e)=> {
        if (e.keyCode == KeyCodeUtils.ENTER) {
            loadDeviceViews();
        }
    };

    // load device views
    let loadDeviceViews = async ()=> {
        // loading animation
        setLoading(true);
        let deviceViewsPage = (await deviceApi.queryViews({
            gatewayId: gatewayView.gateway.id,
            search: search,
            pageNo: tableParams.pagination.current,
            pageSize: tableParams.pagination.pageSize,
        })).data.data;

        let newTableParams = {pagination: {...tableParams.pagination}};
        newTableParams.pagination.total = deviceViewsPage.totalElements;
        setTableParams(newTableParams);
        setDeviceViews(deviceViewsPage.elements);
        setLoading(false);
    };
    
    // column definition
    let columns: ColumnType<any>[] = [
        {
            title: '状态',
            dataIndex: 'node.status',
            key: "node.status",
            align: 'center',
            render: (text, record, index)=> {
                return record.node.status == 'ONLINE' 
                    ? <CheckCircleFilled style={{color: 'green'}} />
                    : <CloseCircleFilled style={{color: 'grey'}} />
            }
        },
        {
            title: '设备名称',
            dataIndex: 'device.name',
            key: 'device.name',
            align: 'center',
            render: (text, record, index)=> {
                return <a onClick={()=> viewDeviceDetails(record)}>{record.device.name}</a>
            }
        },
        {
            title: '设备模板',
            dataIndex: 'template.name',
            key: 'template.name',
            align: 'center',
            render: (text, record, index)=> {
                return <span>{record.deviceTemplate?.name}</span>
            }
        },
        {
            title: '最后在线时间',
            dataIndex: 'node.lastSeenTime',
            key: 'node.lastSeenTime',
            align: 'center',
            render: (text, record, index)=> {
                return <span>{ moment(parseInt(record.node?.lastSeenTime)).format("YYYY-MM-DD HH:mm:ss") }</span>
            }
        },
        {
            title: '操作',
            key: 'action',
            align: 'center',
            render: (text, record, index)=> {
                return <Space size="middle">
                    <a onClick={()=> viewDeviceDetails(record)}>查看详情</a>
                </Space>
            }
        }
    ];

    // effect
    useEffect(()=> {
        loadDeviceViews();
    }, [search]);
    
    // render
    return (
        <GatewaySlaveDevicesWrapper>
            {contextHolder}
            <ToolBarWrapper>
                <ToolBarLeftWrapper>
                    <Space size="middle">
                    </Space>
                </ToolBarLeftWrapper>

                <ToolBarRightWrapper>
                    <Space size="middle">
                        <FilterItem>
                            <FilterItemLabel>搜索</FilterItemLabel>
                            <Input 
                                placeholder="请输入关键字" 
                                suffix={<SearchOutlined />} 
                                size="middle" 
                                value={search} 
                                onChange={(e)=> setSearch(e.target.value)} 
                                onKeyDown={(e)=> onSearchKeyDown(e)}
                            />
                        </FilterItem>
                    </Space>
                </ToolBarRightWrapper>
            </ToolBarWrapper>
            <TableWrapper>
                <Table 
                    rowKey={(record)=> record.device.id}
                    columns={columns} 
                    dataSource={deviceViews}
                    pagination={tableParams.pagination}
                    loading={loading}
                    onChange={onTableChange}
                />
            </TableWrapper>
        </GatewaySlaveDevicesWrapper>
    );
}

export default GatewaySlaveDevices;
